import React from 'react';
import Widget from 'components/Widget/Widget';
import IntegrationChartContent from './components/IntegrationChartContent';
import { integrationMetricList } from '../components/IntegrationMetricList';

const IntegrationReportsChart = (props) => {
  const { data, index, height = 500, configuration } = props;

  const widgetKey =
    data?.defaultFilter?.integration_type + 'widget' + index || 'revenue_widget_' + index;

  return (
    <Widget
      className='h-full'
      widget_key={widgetKey}
      title={data.title}
      index={index}
      disableLimit
      disableStatusFilter
      disableAccountsFilter
      showIntegrationFilters={data?.defaultFilter?.integration_type !== 'custom' ? true : false}
      disableLevelFilter
      data={data}
      load_chart={true}
      default_filter={data?.defaultFilter}
      icon={
        data?.defaultFilter?.integration_type ? (
          <img
            src={`/icons/integrations/${data?.defaultFilter?.integration_type}.svg`}
            className='w-7 h-7 ml-2'
          />
        ) : (
          <img src='/icons/integrations/revenue.svg' className='w-5 h-5 ml-2' />
        )
      }
      configuration={configuration}
      metricsList={integrationMetricList}
      showCustomDesign
      changeMetricsDesign={true}
      showNetworkSwitcher
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <IntegrationChartContent height={height - 55} data={data} widget_key={widgetKey} />
    </Widget>
  );
};

export default IntegrationReportsChart;
